//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
export default {
  async fetch() {
    await Promise.all([
      this.$store.dispatch('pagesStore/getPage', 'nieuwsbrief'),
    ]);
  },
  computed: {
    ...mapState({
      pages: ({ pagesStore: { pages } }) => pages,
    }),
  },
  components: {
    nieuwsbrief: () => import('~/components/forms/nieuwsbrief.vue'),
  },
  head() {
    return {
      title:
        this.pages.nieuwsbrief && this.pages.nieuwsbrief.seo
          ? this.pages.nieuwsbrief.seo.title
          : 'Nieuwsbrief | Info | Meiden van Holland',
      meta: [
        {
          hid: 'title',
          name: 'title',
          content:
            this.pages.nieuwsbrief && this.pages.nieuwsbrief.seo
              ? this.pages.nieuwsbrief.seo.title
              : 'Nieuwsbrief | Info | Meiden van Holland',
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content:
            this.pages.nieuwsbrief && this.pages.nieuwsbrief.seo
              ? this.pages.nieuwsbrief.seo.title
              : 'Nieuwsbrief | Info | Meiden van Holland',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            this.pages.nieuwsbrief && this.pages.nieuwsbrief.seo
              ? this.pages.nieuwsbrief.seo.description
              : 'Wil jij het direct weten als jouw favoriete Meid van Holland weer een geile sexfilm heeft gemaakt? Deze informatie & meer haal je uit onze maandelijkse nieuwsbrief!',
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content:
            this.pages.nieuwsbrief && this.pages.nieuwsbrief.seo
              ? this.pages.nieuwsbrief.seo.description
              : 'Wil jij het direct weten als jouw favoriete Meid van Holland weer een geile sexfilm heeft gemaakt? Deze informatie & meer haal je uit onze maandelijkse nieuwsbrief!',
        },
        {
          hid: 'og:url',
          name: 'og:url',
          content: process.env.FE_URL + '/info/nieuwsbrief',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content:
            this.pages.nieuwsbrief && this.pages.nieuwsbrief.seo
              ? this.pages.nieuwsbrief.seo.keywords
              : 'Nieuwsbrief, nieuws, contact, email, wekelijks, post',
        },
      ],
    };
  },
};
